const Config = {
  redirectUri: "https://conference-voting-frontend.staging.sidearmdev.com/login",
  redirectUriSignout: "https://conference-voting-frontend.staging.sidearmdev.com/logout",
  apiUrlBase: "https://voting.staging.sidearmdev.com",
}

export default Config